"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n            width: 100%;\n            position: relative;\n            height: ", "em;\n            background: ", ";\n        "], ["\n            width: 100%;\n            position: relative;\n            height: ", "em;\n            background: ", ";\n        "]),
    _templateObject2 = _taggedTemplateLiteral(["\n            top: 50%;\n            text-align: right;\n            position: absolute;\n            transform: translateY(-50%);\n            right: ", "em;\n            text-transform: ", ";\n        "], ["\n            top: 50%;\n            text-align: right;\n            position: absolute;\n            transform: translateY(-50%);\n            right: ", "em;\n            text-transform: ", ";\n        "]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserInfo = function (_Component) {
    _inherits(UserInfo, _Component);

    function UserInfo() {
        _classCallCheck(this, UserInfo);

        return _possibleConstructorReturn(this, (UserInfo.__proto__ || Object.getPrototypeOf(UserInfo)).apply(this, arguments));
    }

    _createClass(UserInfo, [{
        key: "render",
        value: function render() {
            var UserInfoContainer = _styledComponents2.default.div(_templateObject, function (props) {
                return props.theme.userInfo.height;
            }, function (props) {
                return props.theme.userInfo.backgroundColor;
            });
            var UserInfo = _styledComponents2.default.div(_templateObject2, function (props) {
                return props.theme.userInfo.padding;
            }, function (props) {
                return props.textTransform;
            });
            return _react2.default.createElement(
                UserInfoContainer,
                null,
                _react2.default.createElement(
                    UserInfo,
                    { textTransform: this.props.textTransform },
                    this.props.children
                )
            );
        }
    }]);

    return UserInfo;
}(_react.Component);

UserInfo.propTypes = {
    /** Text Tranform - A valid css text-transform value */
    textTransform: _propTypes2.default.string
};

UserInfo.defaultProps = {
    textTransform: "none"
};

exports.default = UserInfo;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/userInfo/userInfo.js
// module id = 1024
// module chunks = 95715928098905 168707334958949